/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {getServiceT004, putServiceT004} from '../../core/prestation/request'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {Button, Modal} from 'react-bootstrap'
import {useAuth} from '../../../../auth'
import * as lodash from 'lodash'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {ListeServiceStatus} from '../../core/prestation/model'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'

const initialTBForm4Values = {
  Authorizations: false,
  AuthorizationDetail: '',
  HomeSecurity: false,
  PPSPS: false,
  JointInspectionVisit: false,
  PlansToBeProvided: false,
}

type ToogleButtonForm4Props = {
  isVisible3: boolean
  onDetectChange4?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t004?: ListeServiceStatus
}

const ToogleButtonForm4: FC<ToogleButtonForm4Props> = ({
  isVisible3,
  onDetectChange4,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  onSavedForm,
  t004,
  loadListServiceStatus,
}) => {
  const intl = useIntl()
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [serviceT004, setServiceT004] = useState<any>(null)
  const [t1init, setT1init] = useState<any>(initialTBForm4Values)
  const {setAuthMessage, logout} = useAuth()
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const {mode} = useThemeMode()
  const [loading, setLoading] = useState<boolean>(true)
  const [inputChange, setInputChange] = useState<any>(false)

  // const onRefreshListeService4 = () => {
  //   const services: any[] = [...listeService]
  //   const data = services.find((item) => item === itemProps)
  //   if (data) {
  //     const index = services.findIndex((item) => item === itemProps)
  //     if (index === -1) {
  //       //return
  //     }
  //     services.splice(index, 1, {...itemProps, Completed: true})
  //     setServiceData(itemProps)
  //     setListService(services)
  //   }
  // }

  const loadServiceT004 = async () => {
    const response = await getServiceT004(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT004(response?.data?.data)
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadServiceT004()
  }, [])

  const handleClickT004 = async () => {
    try {
      const dataToUpdate = {
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
        Authorizations: serviceT004?.Authorizations,
        AuthorizationDetail: serviceT004?.AuthorizationDetail,
        HomeSecurity: serviceT004?.HomeSecurity,
        PPSPS: serviceT004?.PPSPS,
        JointInspectionVisit: serviceT004?.JointInspectionVisit,
        PlansToBeProvided: serviceT004?.PlansToBeProvided,
      }
      const response = await putServiceT004(dataToUpdate)
      if (response) {
        console.log('Changements enregistrés !')
      }
      await loadServiceT004()
      if (loadListServiceStatus) {
        loadListServiceStatus()
      }
    } catch (error) {
      console.error('Erreur lors de la sauvegarde :', error)
    }
  }

  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT004, t1init)
  }, [serviceT004, t1init])

  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadServiceT004()
      setShowCancel(false)
    } else {
      setServiceT004({...t1init, AuthorizationDetail: ''})
      await loadServiceT004()
      setShowCancel(false)
    }
  }

  useEffect(() => {
    if (onDetectChange4) {
      onDetectChange4(isDisabled)
    }
  }, [isDisabled, onDetectChange4])

  console.log(serviceT004)

  return (
    <div>
      {isVisible3 && (
        <div className='d-flex flex-column'>
          <form>
            <div className='p-5 mt-8'>
              <div className='d-flex justify-content-between align-items-center'>
                <div
                  className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column '
                  style={{flex: 0.6}}
                >
                  <label className='fs-5 text-gray-700' style={{flex: 0.5}}>
                    {intl.formatMessage({id: 'AUTHORIZATIONS'})}
                  </label>
                  <div className='d-flex gap-10' style={{flex: 0.5}}>
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'YES'})}
                      checked={serviceT004?.Authorizations === true}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT004({...serviceT004, Authorizations: true})
                      }}
                    />
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'NO'})}
                      checked={serviceT004?.Authorizations === false}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT004({...serviceT004, Authorizations: false})
                      }}
                    />
                  </div>
                </div>
                <div style={{flex: 0.4}} className='d-flex justify-content-end'>
                  {/*<CenterHelp />*/}
                </div>
              </div>
              {serviceT004?.Authorizations === true && (
                <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700' style={{flex: 0.3}}>
                  {intl.formatMessage({id: 'AUTHORIZATION.DETAILS'})}
                </label>
                <div style={{flex: 0.7}}>
                  <textarea
                    className='form-control form-control-solid py-4 text-dark fst-italic fs-7'
                    readOnly={Submitted}
                    rows={
                      serviceT004?.AuthorizationDetail?.length > 200 &&
                      serviceT004?.AuthorizationDetail?.length < 300
                        ? 6
                        : serviceT004?.AuthorizationDetail?.length > 300
                        ? 9
                        : 3
                    }
                    placeholder={intl.formatMessage({
                      id: 'REPORT.HERE.THE.DESCRIPTION.PROVIDED.BY.THE.CLIENT',
                    })}
                    value={serviceT004?.AuthorizationDetail ?? ''}
                    onChange={(e) => {
                      setServiceT004({...serviceT004, AuthorizationDetail: e.target.value})
                      setInputChange(true)
                    }}
                  />
                </div>
              </div>
              )}

              <div className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700' style={{flex: 0.3}}>
                  {intl.formatMessage({id: 'SECURITY.RECEPTION'})}
                </label>
                <div className='d-flex gap-10' style={{flex: 0.7}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT004?.HomeSecurity === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, HomeSecurity: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT004?.HomeSecurity === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, HomeSecurity: false})
                    }}
                  />
                </div>
              </div>

              <div className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700' style={{flex: 0.3}}>
                  PPSPS
                </label>
                <div className='d-flex gap-10' style={{flex: 0.7}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT004?.PPSPS === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, PPSPS: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT004?.PPSPS === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, PPSPS: false})
                    }}
                  />
                </div>
              </div>

              <div className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700' style={{flex: 0.3}}>
                  {intl.formatMessage({id: 'JOIN.INSPECTION.VISIT'})}
                </label>
                <div className='d-flex gap-10' style={{flex: 0.7}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT004?.JointInspectionVisit === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, JointInspectionVisit: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT004?.JointInspectionVisit === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, JointInspectionVisit: false})
                    }}
                  />
                </div>
              </div>

              <div className='gap-5 d-flex justify-content-xl-between justify-content-lg-between  flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column my-5'>
                <label className='fs-5 text-gray-700' style={{flex: 0.3}}>
                  {intl.formatMessage({id: 'PLANS.TO.PROVIDE'})}
                </label>
                <div className='d-flex gap-10' style={{flex: 0.7}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT004?.PlansToBeProvided === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, PlansToBeProvided: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT004?.PlansToBeProvided === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT004({...serviceT004, PlansToBeProvided: false})
                    }}
                  />
                </div>
              </div>

              {!Submitted && (
                <div className='d-flex gap-5 justify-content-end my-5'>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      className='btn btn-dark'
                      disabled={isDisabled}
                      onClick={() => {
                        if (!lodash.isEqual(serviceT004, t1init)) {
                          setShowCancel(true)
                        } else {
                          if (inputChange) {
                            setServiceT004({...t1init})
                            setInputChange(false)
                          }
                        }
                      }}
                    >
                      {intl.formatMessage({id: 'RESET'})}
                      <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                    </Button>
                  </span>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      type='button'
                      className='btn btn-danger'
                      onClick={handleClickT004}
                      disabled={isDisabled}
                    >
                      {intl.formatMessage({id: 'SAVE'})}
                      <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                    </Button>
                  </span>
                </div>
              )}
            </div>
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToogleButtonForm4
